import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class LoggerService {

    private static getMessage(className: string, methodName: string, args?: any): { message: string, result: any } {
        let message = `[${className}] ${methodName}`;
        let result = '';
        if (args && typeof (args) == 'string') {
            message += `, ${args}`;
        } else if (args && typeof (args) == 'object') {
            result = args;
        }
        return { message, result };
    }

    /** Log level INFO */
    static logInfo(className: string, methodName: string, args?: any, forceLog = false): void {
        if (environment.enabledLoggerService || forceLog) {
            const { message, result } = LoggerService.getMessage(className, methodName, args);
            console.info(message, result);
        }
    }

    /** Log level DEBUG */
    static logDebug(className: string, methodName: string, args?: any, forceLog = false): void {
        if (environment.enabledLoggerService || forceLog) {
            const { message, result } = LoggerService.getMessage(className, methodName, args);
            console.debug(message, result);
        }
    }

    /** Log level WARN */
    static logWarn(className: string, methodName: string, args?: any, forceLog = false): void {
        if (environment.enabledLoggerService || forceLog) {
            const { message, result } = LoggerService.getMessage(className, methodName, args);
            console.warn(message, result);
        }
    }

    /** Log level ERROR */
    static logError(className: string, methodName: string, args?: any, forceLog = false): void {
        if (environment.enabledLoggerService || forceLog) {
            const { message, result } = LoggerService.getMessage(className, methodName, args);
            console.error(message, result);
        }
    }

}
